// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iyRON","headingWrapper":"styles_headingWrapper__cxeCR","headingText":"styles_headingText__+MKq0"};